<template>
  <main class="main">
    <pur-cont-modal ref="pcm"></pur-cont-modal>
    <loading-container :loading="loading" >
      <div v-if="!purchaser&&!red" class="header">
        <div class="tabs">
          <router-link :to="name" v-for="({name, title}, key) in navs" :key="key+'nav_org'" class="tabs-item" tag="div" active-class="active">
            {{ title }}
          </router-link>
          <div class="tabs-item" tag="div" active-class="active" @click="sendMessage">Чат</div>
        </div>
        <div v-if="!purchaser" class="stat"> Статус:<div :style="0 ? 'color: rgba(44, 177, 129, 1)' : status == 2 ? 'color: rgba(235, 87, 87, 1)' :  status == 3 ? 'color: rgba(243, 146, 32, 1)' : ''"><!--{{
            false ? 'Заключается договор' :
                status == 1 ? 'В ожидании' :
                    status == 2 ? 'Отклонено'
                        : status == 3 ? 'Потенциально интересно'
                        : ""}}--> {{human_status}}</div></div>
        <!--        <button>Отправить другому клиенту</button>-->
      </div>
      <div v-if="purchaser&&!red" class="header">
        <div class="tabs">
          <router-link :to="name" v-for="({name, title}, key) in pnavs" :key="key+'nav_org'" class="tabs-item" tag="div" active-class="active">
            {{ title }}
          </router-link>
          <div class="tabs-item" tag="div" active-class="active" @click="sendMessage">Чат</div>
        </div>
        <button v-if="isset_contract && human_status != 'Истек'" @click="$refs.pcm.open(provider_id)">Заключить договор</button>
        <button class="outline" v-if="human_status != 'Истек'" @click="changeStatus(3)">Потенциально интересно</button>
        <button class="outline" v-if="human_status != 'Истек'" @click="changeStatus(2)">Отклонить</button>
      </div>
      <div v-if="!purchaser&&red" class="header">
        <div class="wrp">
          <h4>Клиент</h4>
          <app-select :options="clients" :multiple="true" @input="client = $event" :value="client"/>
          <span class="text-danger text-sm" v-if="error_client">{{ error_client }}</span>
        </div>
        <div class="wrp">
          <h4>Действует до</h4>
          <div class="calendar">
            <div class="input-block">
              <date-picker v-model="date_issue" @change="validateDate"></date-picker>
              <span class="text-danger text-sm" v-if="error_date || error_date">{{ error_date }}</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 21px; margin-left: auto;">
          <button  @click="sendToClient" >Отправить клиенту</button>
          <span class="text-danger text-sm" style="margin-left:42px;" v-if="error_no_offer_id">{{ error_no_offer_id }}</span>
        </div>
      </div>
      <div class="info" v-if="!red">
        <div class="info-item">
          <div class="title">ID КП</div>
          <div class="text">{{ id }}</div>
        </div>
        <div class="info-item">
          <div class="title">Дата КП</div>
          <div class="text">{{created_at}}</div>
        </div>
        <div class="info-item">
          <div class="title">{{  !purchaser ? 'Клиент' : 'Поставщик'  }}</div>
          <div class="text">{{client_name}}<img src="../assets/icons/doc_success.svg" alt=""></div>
        </div>
        <div class="info-item">
          <div class="title">Действует до</div>
          <div class="text" >{{ date_issue }}</div>
        </div>
      </div>
      <h4 v-if="red">Текст предложения</h4>
      <textarea v-if="red" name="" id="" v-model="comment" ></textarea>
      <div>
        <span class="text-danger text-sm" v-if="error_comment">{{ error_comment }}</span>
      </div>

      <img v-if="red" src="../assets/icons/chat/paperclip.svg" @click="fileInput" alt="" class="add">
      <input v-if="red" type="file" ref="file" accept=".jpg, .jpeg, .png, .bmp, .gif, .pdf, .svg, .txt, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .xls, .xlsx, .csv" hidden @change="onFileChange">
      <div v-if="file_error" class="error">{{file_error}}</div>
      <br>
      <div>
        <div v-for="(file, key) in files" :key="'file-' + file.id">
            <span>
                <a class="file-link" target="_blank" :href="file.full_url">{{file.original_name}}</a>
            </span>
            <span class="cp">
                <img class="hover_btn" src="@/assets/img/worker/delete.svg" alt="" @click="deleteFile(file.id, key)">
            </span>
        </div>
      </div>
      <br v-if="!red">

      <div class="message" v-if="!red">{{comment}}</div>
      <div class="table">
        <table v-if="offer" style="margin-bottom:1%">
          <tr>
            <th style="width: 35px;"></th>
            <th>Артикул</th>
            <th>Наименование товара</th>
            <th>Бренд</th>
            <th>Цена ОПТ, ₽ </th>
            <th>Цена РРЦ, ₽  </th>
          </tr>
          <tr v-for="(item, idx) in offer" :key="idx">
            <td><img :src="item.product.image ? item.product.image.image : ''" alt=""></td>
            <td>
              <router-link :to="'/product/'+item.product.id" class="link">
                {{item.product.article}}
              </router-link>
            </td>
            <td>{{item.product.name}}</td>
            <td>{{item.product.main_attr != null && item.product.main_attr.brand ?  item.product.main_attr.brand : '' }}</td>
            <td style="color: #2cb181">{{item.product.price_opt}} {{item.product.currency}}</td>
            <td style="color: #2cb181">{{item.product.price_rcc}} {{item.product.currency}}</td>
          </tr>
        </table>

        <template v-if="red">
          <div class="label-search">Здесь можно добавить товары к КП:</div>
          <div class="search">
            <input autocomplete="off" name="search" v-model="search" placeholder="Поиск" @keyup="searchProducts()">
            <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
          </div>
          <div class="result">
            <div class="title" v-if="search">Найдено {{result.length}} </div>
            <div class="table flex row tab_overflow">
              <table class="col-12">
                <tr>
                  <th>Наименование</th>
                  <th>Артикул</th>
                  <!--<th>Поставщик</th>-->
                  <th width="120px">Цена, руб.</th>
                  <th>Остаток</th>
                  <th>
                    <app-checkbox/>
                  </th>
                </tr>
                <tr v-for="(item, idx) in result" :key="idx" class="tc">
                  <td>{{item.name}}</td>
                  <td>{{item.article}}</td>
                  <!--<td>{{result.supplier}}</td>-->
                  <td class="text-right">{{item.price_rcc | currency}}</td>
                  <td style="color: #2CB181" class="text-right">{{item.quantity}}</td>
                  <td width="40px">
                    <app-checkbox v-model="item.checked"/>
                  </td>
                </tr>
              </table>
              <span class="text-danger text-sm" v-if="error_products">{{ error_products }}</span>
            </div>
            <div class="col-12" style="display: flex; justify-content: center;">
              <button v-if="red" @click="addToOrder" style="margin-left: 80px;">Добавить товар</button>
            </div>
          </div>
        </template>
      </div>
      <button style="margin-top: 21px; margin-left: auto;"  v-if="purchaser && !isset_contract && human_status != 'Истек'" @click="createOrder">Создать заказ</button>
    </loading-container>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppSelect from "@/components/app-select";
import AppCheckbox from "@/components/app-checkbox";
import PurContModal from "@/components/modals/purchaser-contract-modal";

export default {
  name: "offer",
  components: {
    LoadingContainer,
    AppSelect,
    AppCheckbox,
    PurContModal
  },
  data: ()=>({
    loading: false,
    purchaser: false,
    red: false,
    date_issue: '',
    search: '',
    pnavs: [
      {
        title: 'КП',
        name: '/offers',
      },
      {
        title: 'Поставщик',
        name: '/organization/suppliers',
      },
      // {
      //   title: 'Чат',
      //   name: '/chat',
      // },


    ],
    navs: [
      {
        title: 'КП',
        name: '/offers',
      },
      {
        title: 'Клиент',
        name: '/organization/suppliers',
      },
      // {
      //   title: 'Чат',
      //   name: '/chat',
      // },
    ],
    offer: null,
    clients: [],
    client: null,
    client_name: null,
    id: null,
    status: null,
    created_at: null,
    result: [],
    comment: '',
    params_id: null,
    offer_id: null,
    provider_id: null,
    isset_contract: null,
    products: [],
    company_id: null,

    error_products: null,
    error_client: null,
    error_date: null,
    error_no_offer_id: null,
    error_comment: null,
    files: [],
    file_error: '',
    human_status: ''
  }),
  mounted() {
    this.params_id = this.$route.params.id ? this.$route.params.id : null;
    this.purchaser = localStorage.getItem('type') == 1 ? false : true;

    if (this.$route.name == 'Offer_Edit' || this.$route.name == 'Offer_Create'){
      this.red = true;
    }else {
      this.red = false;
    }
    this.getMyClients();
    if (this.params_id){
      this.getOffer()
      this.$route.meta.title = 'КП N '+this.params_id;
      this.$root.$emit('changeHeaderTitle', 'КП N '+this.params_id);
    }
  },
  methods: {
    validateDate(){
      this.error_date = null;
      if (this.$moment().unix() > this.$moment(this.date_issue).unix()){
        this.error_date = 'Дата действия КП не может быть меньше текущей';
      }
    },
    changeStatus(val) {
      if (localStorage.getItem('token')) {
        this.$http.post('/change-offer-status', {
          token: localStorage.getItem('token'),
          id: this.params_id ? this.params_id : this.offer_id,
          status: val
        }).then(({data}) => {
          if (data.success) {
            this.$emit('getOffer')
            this.$toast.success('Статус успешно изменен!');
            this.item.status = val;
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    fileInput() {
      this.$refs.file.click();
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('token', localStorage.getItem('token'));
      formData.append('name', e.target.files[0].name);
      if (this.offer_id) {
        formData.append('offer_id', this.offer_id);
      }
      this.$http.post( '/upload-offer-file',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
      ).then((response) => {
        if (response.data) {
          this.files.push(response.data);
          if (!this.offer_id) {
            this.offer_id = response.data.offer_id;
          }
        }
      }).catch((error) => {
        if (error.response && error.response.data.errors) {
          for (const key in error.response.data.errors) {
            if (key == 'file') {
              this.file_error = error.response.data.errors[key][0];
            }
          }
        }
      })
    },
    sendToClient() {
      this.error_no_offer_id = null;
      this.error_comment = null;
      this.error_date = null;
      this.error_client = null;

      if (!this.params_id && !this.offer_id){
          this.error_no_offer_id = 'Добавьте товар'
      }

      if (!this.comment){
          this.error_comment = 'Добавьте Текст предложения'
      }

      if (!this.date_issue){
          this.error_date = 'Добавьте дату действия'
      }

      if (!this.client){
          this.error_client = 'Выберите клиента';
      }
      if (this.$moment().unix() > this.$moment(this.date_issue).unix()){
        this.error_date = 'Дата действия КП не может быть меньше текущей';
      }
      if (!this.date_issue_error && !this.error_no_offer_id && !this.error_comment && !this.error_date && !this.error_client) {
        this.$http.post('/create-offer', {
          token: localStorage.getItem('token'),
          // products: this.products,
          add_product_offer: false,
          comment: this.comment,
          active_to_date: this.date_issue,
          clients: this.client,
          offer_id: this.params_id ? this.params_id : this.offer_id,
        }).then(({data}) => {
          if (data.success) {
            this.$toast.success('КП успешно создано!');
            this.$router.push('/offers')
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    getOffer() {
      this.$http.post('/get-offer', {
        token: localStorage.getItem('token'),
        id: this.params_id ? this.params_id : this.offer_id,
      }).then(({data}) => {
        if (data.offer){
          this.comment = data.offer.comment;
          if (!this.red) {
            this.date_issue = this.$moment(data.offer.active_to_date).format('DD - MMMM - YYYY');
          }else {
            this.date_issue = data.offer.active_to_date;
          }
          if (data.offer.purchaser) {
            this.client = {id: data.offer.purchaser.id, label: data.offer.purchaser.name}
            if (!this.purchaser) {
              this.client_name = data.offer.purchaser.name;
            }
          }

          this.offer = data.offer.offer_product;
          this.offer_id = data.offer.id;
          this.created_at = this.$moment(data.offer.created_at).format('DD - MMMM - YYYY');
          this.id = data.offer.id;
          this.status = data.offer.status;
          this.isset_contract = data.isset_contract;
          this.files = data.offer.files;
          this.human_status = data.offer.human_status;
          if (data.offer.provider) {
            this.provider_id = data.offer.provider_id;
            this.pnavs[1]['name'] ='/profile/'+data.offer.provider.id;
            if (this.purchaser) {
              this.client_name = data.offer.provider.name;
            }
          }
          if (data.offer.purchaser){
            this.navs[1]['name'] ='/profile/'+data.offer.purchaser.id;
          }
          this.company_id = data.company.id;
        }
      }).catch((error) => {
        console.log(error)
      })
      console.log(this.offer);
    },
    sendMessage() {
      if (localStorage.getItem('token')) {
        this.$http.post('/create-chat', {
          token: localStorage.getItem('token'),
          id: this.company_id,
        }).then(({data}) => {
          if (data.success) {
            this.$router.push('/chat?company=' + this.company_id);
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    deleteFile(id, key) {
      if (localStorage.getItem('token')) {
        this.$http.post('/delete-offer-file', {
          token: localStorage.getItem('token'),
          id: id
        }).then(({data}) => {
          if (data.success) {
            this.files.splice(key, 1);
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },
    searchProducts() {

      if (this.search.length > 1) {
        this.$http.post('/search-order-my-products', {
          token: localStorage.getItem('token'),
          search: this.search,
          id: this.$route.params.id
        }).then(({data}) => {
          if (data.items) {
            for (let key in data.items) {
              data.items[key].checked = false;
            }
            this.result = data.items;
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    getMyClients() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-my-clients', {
          token: localStorage.getItem('token')
        }).then(({data}) => {
          if (data.clients) {
            this.clients = data.clients;
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    addToOrder() {
      this.error_no_offer_id = null;
      this.error_products = null;

      for (let key in this.result) {
        if (this.result[key].checked) {
          this.products.push(this.result[key].id);
        }
      }
      if (!this.products.length){
        this.error_products = 'Выберите товар';
      }
      // params_id
      if (!this.error_products) {
        this.$http.post('/create-offer', {
          token: localStorage.getItem('token'),
          products: this.products,
          comment: this.comment,
          active_to_date: this.date_issue,
          client: this.client,
          offer_id: this.params_id ? this.params_id : this.offer_id ,
          add_product_offer: true,
        }).then(({data}) => {
          if (data.success) {
            this.offer_id = data.offer_id;
            this.products = [];
            this.result = [];
            this.$toast.success('Успешно добавлено!');
            this.getOffer();
          }
        }).catch((error) => {
          console.log(error)
        })
      }

    },
    createOrder() {
      this.$http.post ( '/create-order-offer',{
        token: localStorage.getItem('token'),
        offer_id: this.params_id
      }).then(({data}) => {
          if(data.success){
            this.$toast.success('Заказ успешно сформирован!');
            if(localStorage.getItem('type' ) == 2){
             this.$router.push({name: 'opur'});
            }
          }
      }).catch((error) => {console.log(error)})
    },
  },
  watch: {
  }
}
</script>
<style>
.cp {
    cursor: pointer;
    margin-left: 16px;
}
.v-select{
  margin-bottom: 0;
}
</style>


<style scoped lang="scss">

.error {
  color: red;
  font-size: 12px;
}
.add {
  cursor: pointer;
  margin: 6px 0px 6px 0px;
}
.file-link {
  color: #2CB181;
}
textarea{
  width: calc(60% + 15px);
  height: 150px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  border-radius: 4px;
  resize: none;
}
button{
  margin-top: auto;
  margin-left: 15px;
  border: none;
  height: 40px;
  padding: 0 25px;
  background: #2CB181;
  border-radius: 4px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  &.outline{
    background: none;
    border: 1px solid #B6BCC8;
    color: #636974;
  }
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
}
.header {
  height: 40px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  .wrp{
    width: 30%;
    margin-right: 15px;
  }
  .tabs{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    width: max-content;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
    margin-right: auto;

    &-item {
      margin: 0;
      position: relative;
      cursor: pointer;
      padding: 10px 15px;
      margin: 2px 0 2px 0;
      color: #7A818F;
    }
    &-item:first-child{
      margin-left: 2px;
    }
    &-item:last-child{
      margin-right: 2px;
    }
    &-item.active {
      background: #EEF0F3;
      border-radius: 4px;
    }

    &-item:after{
      border-left: 1px solid #EEF0F3;
      content: " ";
      position: absolute;
      top: 35%;
      right: 0;
      height: 30%;
      margin-top: auto;
      margin-bottom: auto;
    }
    &-item:last-child:after{
      border-left: unset;
    }
  }
  .stat{
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #636974;
    .status{
      margin-left: 5px;
      color: #EB5757;
    }
  }
}
.tab_overflow{
  overflow: auto;
  max-height: 543px;
  width:60%;
}
.info{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 35px;
  margin-top: 30px;
  &-item{
    width: max-content;
    margin-right: 40px;
    .title{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7A818F;
      margin-bottom: 5px;
      .other{
        color: black;
        margin-left: 5px;
      }
    }
    .text{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
      img{
        margin-left: 5px;
      }
    }
  }
}
.message{
  max-width: 50%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #636974;
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        img{
          height: 32px;

        }
      }
    }

  }
}
.search > img {
  position: absolute;
  right: 15px;
  bottom: 50%;
  transform: translateY(50%);
  width: 14px;
  height: 14px;
}
.search > input {
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  padding: 0 40px 0 15px;
  outline: none;
}
.search {
  position: relative;
  width: 20%;
  display: flex;
  justify-content: flex-end;
}

</style>
